import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32, FctValue } from '../../../../Fct/generics';
import { secureStorageAddressFrom, secureStorageAddresses } from '../helpers/constants';
export var Write_fct_uint256 = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'ACTION',
    method: 'write_fct_uint256',
    supportedContracts: secureStorageAddresses,
    payerIndex: 0,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                from: new FctAddress({ value: secureStorageAddressFrom[chainId], readonly: true }),
                methodParams: {
                    key: new FctBytes32({ messageType: 'stringOrBytes32' }),
                    value: new FctValue({}),
                },
            },
            output: {},
        });
    },
});
